import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { fetch } from "@/plugins/fetchPlugin";
import NoticeView from "@/components/NoticeFormView.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  props: {
  operationId: {
    type: String,
    default: undefined,
  },
  op: {
    type: Object,
    default: undefined,
  },
  subId: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;



const notice = ref(false);

const sended = ref(false);

const error = ref({
  lastname: false,
  firstname: false,
  email: false,
  type: false,
  subject: false,
  message: false,
});

const form = ref({
  lastname: "",
  firstname: "",
  email: "",
  type: "",
  subject: "",
  message: "",
});

const sendEmail = async () => {
  try {
    if (!form.value.lastname) {
      error.value.lastname = true;
    }
    if (!form.value.firstname) {
      error.value.firstname = true;
    }
    if (!form.value.email) {
      error.value.email = true;
    }
    if (!form.value.type) {
      error.value.type = true;
    }
    if (!form.value.subject) {
      error.value.subject = true;
    }
    if (!form.value.message) {
      error.value.message = true;
    }

    if (
      !form.value.lastname ||
      !form.value.firstname ||
      !form.value.email ||
      !form.value.type ||
      !form.value.subject ||
      !form.value.message
    ) {
      return;
    }

    let to = null;

    await fetch(`/api/operations-custom/promodev-send-contact/sendmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to: to,
        subid: props.subId,
        operationId: props.operationId,
        nom: form.value.lastname,
        prenom: form.value.firstname,
        email: form.value.email,
        demande: form.value.type,
        objet: form.value.subject,
        message: form.value.message,
        type: "contact",
      }),
    });

    sended.value = true;
  } catch (e) {
    console.error(e);
  }
};

onMounted(() => {
  if (props.op.custom.rgpdcontact) {
    const noticeElement = document.getElementById("notice");
    if (noticeElement) {
      noticeElement.addEventListener("click", () => {
        notice.value = true;
      });
    }
  }
});

return { __sfc: true,props, notice, sended, error, form, sendEmail, NoticeView }
}

})